export default "__VITE_ASSET__BblqVZkM__"